<div class="p-2">
  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">Coupon List</div>
  </div>

  <div class="row bg-light">
    <div class="col-12 p-2">

      <!-- Filters -->
      <div class="row bg-white pt-2 pb-2">
        <div class="col-12">
          <app-page-filters page="coupon-list" [showCouponSource]="false" [showCalendar]="false" (filterChange)="onPageFilterChange($event)"></app-page-filters>
        </div>
      </div>

      <!-- Coupons -->
      <!-- Loading -->
      <div class="row mt-4 pt-4 mb-4 pb-4 text-center" *ngIf="couponsLoading === true"> 
        <div class="col-12">
          <div class="spinner-border text-info  mt-4" role="status"></div>
        </div>
      </div>

      <div class="row mt-2 pt-2 pb-4">
        <div class="col-12">
          <!-- Empty message -->
          <div class="row text-center mt-4 mb-4" *ngIf="couponsLoading == false && coupons.length == 0"> 
            <i-bs class="text-black-50 mt-4 pt-4" name="tags" width="30" height="30"></i-bs>
            <div class="col-12 mb-4 pb-4 text-black-50">Coupons not found</div>
          </div>

          <!-- Display coupon -->
          <div class="row" *ngIf="couponsCount > 0"> 
            <div class="col-2"> <!-- Display Type -->
              <span style="margin-left: 10px;">
                <i-bs [class]="displayType == 'grid' ? 'text-secondary' : 'text-black-50 cursor-pointer'" name="grid" width="20" height="20" title="Grid view" (click)="changeDisplayType('grid')"></i-bs>
                <i-bs [class]="displayType == 'list' ? 'text-secondary' : 'text-black-50 cursor-pointer'" style="margin-left: 10px;" name="list" width="20" height="40" title="List view" (click)="changeDisplayType('list')"></i-bs>
              </span>
            </div>
            <div class="col-10"> <!-- Pagination Top -->
              <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCouponsPageChange($event)"></pagination-controls>
            </div>
          </div>

          <!-- Grid -->
          <div class="row" *ngIf="couponsLoading === false && coupons.length > 0 && displayType == 'grid'">
            <div class="col-12 col-md-4 mb-3" *ngFor="let coupon of coupons | paginate: { itemsPerPage: 9, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
              <app-show-coupon [module]="loginData?.user_details.provider_type" [couponListData]="coupons" [couponData]="coupon" [couponStoreId]="pageFilterData?.store" [displayType]="displayType" >
              </app-show-coupon>
            </div>
          </div>

          <!-- List -->
          <div class="row" *ngIf="couponsLoading === false && coupons.length > 0 && displayType == 'list'">
            <div class="col-12" *ngFor="let coupon of coupons | paginate: { itemsPerPage: 9, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
              <app-show-coupon [module]="loginData?.user_details.provider_type" [couponListData]="coupons" [couponData]="coupons[0]" [couponStoreId]="pageFilterData?.store" [displayType]="displayType" *ngIf="i == 0">
              </app-show-coupon>
            </div>
          </div>

          <!-- Pagination Bottom -->
          <div class="row mt-2">
            <div class="col-12">
              <pagination-controls class="float-end" style="font-size:12px" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCouponsPageChange($event)" *ngIf="couponsCount > 0"></pagination-controls>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
